import { render } from "./Topup.vue?vue&type=template&id=19f9bdc3"
import script from "./Topup.vue?vue&type=script&lang=js"
export * from "./Topup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__